import React from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { CustomCtaOption, PMCConfig } from '@kyruus/types';
import { ExtendedProvider, Log } from 'Src/types';
import { CtaListItemBase, ListItemButtonProps } from './CtaListItemBase';
import { getCustomListItemUrl, trackListItemClick } from '../../lib';

interface BaseCustomListItemProps {
  provider: ExtendedProvider;
  customOption: CustomCtaOption;
  config: PMCConfig;
  log: Log;
}

type CustomListItemProps = BaseCustomListItemProps & WrappedComponentProps;

export const CustomListItem = injectIntl(
  ({ provider, customOption, log, config }: CustomListItemProps) => {
    const href = getCustomListItemUrl({ customOption, provider });
    if (!href) {
      return null;
    }
    const applicationStringTemplates =
      config.application_string_templates || {};
    const primaryText =
      applicationStringTemplates[`booking_options.${customOption.id}.title`] ??
      '';
    const secondaryText =
      applicationStringTemplates[
        `booking_options.${customOption.id}.subtitle`
      ] ?? undefined;

    const handleClick = () => {
      trackListItemClick({
        listItem: customOption,
        log,
        providerId: provider.id,
        primaryText,
        secondaryText
      });
    };

    const buttonProps: ListItemButtonProps = {
      component: 'a',
      href: href,
      role: 'link',
      target: '_blank',
      rel: 'noopener noreferrer',
      onClick: handleClick
    };
    return (
      <CtaListItemBase
        buttonProps={buttonProps}
        isExternalLink={true}
        primaryText={primaryText}
        secondaryText={secondaryText}
      />
    );
  }
);
